import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Switch,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { CircleNotifications } from '@mui/icons-material';

const CodingDetails = ({ modificar = {}, onSave, isDisabled = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [serviceDate, setServiceDate] = useState(modificar.ServiceDate || null);
  const [notesSigned, setNotesSigned] = useState(modificar.WereNotesSingned || false);
  const [chargeSlip, setChargeSlip] = useState(modificar.Waschargeslipcompleted || false);
  const [comments, setComments] = useState(modificar.RelatidComments || []);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [staffName, setStaffName] = useState(modificar.PCPName || '');
  const timestamp = new Date().toLocaleString(); 

  const handleSave = () => {
    const updated = new Date().toISOString();
    const UpdateData = modificar;
    UpdateData.ServiceDate = serviceDate;
    UpdateData.WereNotesSingned = notesSigned;
    UpdateData.Waschargeslipcompleted = chargeSlip;
    UpdateData.updated = updated;
    UpdateData.RelatidComments = comments;
    onSave(UpdateData);
    setIsEditing(false);
  };

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleDateString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, StaffName: staffName }];
    setComments(updatedComments);
    setNewComment('');
    setOpenCommentDialog(false);
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">PrePost Chart</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>Edit</Button>
        )}
      </Box>

      {/* Member Info */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item width="100%">
            <Box display="flex" alignItems="center">
              <CircleNotifications sx={{ color: 'green', fontSize: 30, mr: 1 }} />
              <Typography>
                <strong>Audit Charts</strong>
              </Typography>
            </Box>
          </Grid>
          <Grid item width="100%">
            <Button
              fullWidth
              variant="contained"
              sx={{ backgroundColor: '#bdbdbd', color: 'black', '&:hover': { backgroundColor: '#9e9e9e' }}}
            >
              <Typography sx={{ color: '#117a65' }}>New</Typography>
            </Button>
          </Grid>
          <TextField
            fullWidth
            value={timestamp}
            disabled
          />
        </Grid>
      </Paper>
    </Container>
  );
};

export default CodingDetails;
